import { z } from "zod";
/**
 * Wraps a schema for an optional environment variable so an empty string (what every `.env` file
 * produces for `KEY=` with nothing after the `=`, and what `docker-compose.yml`'s
 * `${VAR:-}`-style interpolation produces when unset) is treated the same as the key being
 * absent entirely, rather than failing a `.min(1)`/format check as if `""` were a real value.
 *
 * Without this, `z.string().min(1).optional()` rejects `AWS_REGION=` (empty) even though the
 * intent — and every `.env.example` convention — is "not configured".
 */
export function optionalEnv(schema) {
    return z.preprocess((value) => (value === "" ? undefined : value), schema.optional());
}
/**
 * Builds a strict env schema and parses `process.env` (or an injected record) against it,
 * failing fast with a readable message. Used by every app's `env.ts` so a missing/invalid
 * environment variable is a startup error, never a silent `undefined` at runtime.
 */
export function parseEnv(schema, source = process.env) {
    const result = schema.safeParse(source);
    if (!result.success) {
        const issues = result.error.issues.map((issue) => `  - ${issue.path.join(".") || "(root)"}: ${issue.message}`).join("\n");
        throw new Error(`Invalid environment configuration:\n${issues}`);
    }
    return result.data;
}
export const nodeEnvSchema = z.enum(["development", "test", "production"]).default("development");
//# sourceMappingURL=env.js.map